module.exports = __webpack_public_path__ + "img/b_KalsiyForte_front_2.00718746.jpeg";